import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.8004 2.25879H19.8928L13.1369 9.98032L21.0846 20.4876H14.8616L9.9875 14.115L4.41042 20.4876H1.3162L8.54228 12.2285L0.917969 2.25879H7.29899L11.7047 8.08359L16.8004 2.25879ZM15.7151 18.6367H17.4286L6.36791 4.01249H4.52914L15.7151 18.6367Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }